import React from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames/bind';

import TooltipCommerceStore from 'components/TooltipCommerce';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import styles from './ItemVariantsFields.css';

const ItemVariantEcommerce = props => {
  const { member, isDisableForm, index, fields, ecommerceAttributes } = props;
  const cx = classNames.bind(styles);
  const isHide =
    fields.length === 1 &&
    (fields.get(index).name === undefined ||
      fields.get(index).name === null ||
      fields.get(index).name === '');
  const isFirstColumn = index === 0;
  const priceContainerClassName = cx('form-group', {
    'col-md-6': isHide,
    'col-md-4': !isHide,
    'no-padding': !isHide,
  });
  const skuContainerClassName = cx('form-group', {
    'col-md-6': isHide,
    'col-md-4': !isHide,
  });
  return (
    <div className="mk-grouped-input">
      {!isHide && (
        <div className={`form-group col-md-4`}>
          {isFirstColumn && (
            <div className={`panel-heading ${styles['panel-head']}`}>
              <label>Variant Name</label>
            </div>
          )}
          <Field
            name={`${member}.name`}
            component={SettingField}
            className="form-control"
            inputClassName={ecommerceAttributes && styles['input-ecommerce']}
            placeholder="Name"
            dis={isDisableForm || fields.get(index).is_generated}
          />
        </div>
      )}

      <div className={priceContainerClassName}>
        {isFirstColumn && (
          <div className={`panel-heading ${styles['panel-head']}`}>
            <TooltipCommerceStore
              placement="top"
              delay={200}
              name={'basePrice'}
            >
              <label>
                Base Price
                <span
                  className={`glyphicon glyphicon-info-sign ${
                    styles['icon-container']
                  }`}
                />
              </label>
            </TooltipCommerceStore>
          </div>
        )}

        <Field
          name={`${member}.price`}
          component={SettingField}
          placeholder="Price"
          inputClassName={`text-right ${ecommerceAttributes &&
            styles['input-ecommerce']}`}
          positiveNumberOnly
          dis={isDisableForm}
        />
      </div>

      <div className={`form-group ${skuContainerClassName}`}>
        {isFirstColumn && (
          <div className={`panel-heading ${styles['panel-head']}`}>
            <TooltipCommerceStore placement="top" delay={200} name={'sku'}>
              <label>
                SKU
                <span
                  className={`glyphicon glyphicon-info-sign ${
                    styles['icon-container']
                  }`}
                />
              </label>
            </TooltipCommerceStore>
          </div>
        )}
        <Field
          name={`${member}.sku`}
          component="input"
          disabled={isDisableForm}
          className={`form-control text-align-last-left ${
            styles['input-ecommerce']
          }`}
          placeholder="SKU"
        />
      </div>
    </div>
  );
};

export default ItemVariantEcommerce;
